newOptimisticData